import React from 'react';
import clsx from 'clsx';

import { Row, T8y } from 'ui';

import style from './completedPostcode.module.scss';

export const CompletedPostcode = ({
  addressByPostcode,
  handleFindNewAddressClick,
  isWholeSectionDisabled,
  isMobile,
}) => {
  if (isMobile) {
    return (
      <div className={style.completedPostcode}>
        <Row justify="stretch" className={style.addressHeaderLine}>
          <T8y variant="t2v1" color="wilkoBlack" boldLight>
            {addressByPostcode.postcode}
          </T8y>
          <T8y
            variant="t2v1"
            onClick={
              isWholeSectionDisabled ? undefined : handleFindNewAddressClick
            }
            noWrap
            pointer
            asLink
            boldLight
            className={clsx(
              style.changeAddress,
              isWholeSectionDisabled && style.disabled,
            )}
          >
            Change postcode
          </T8y>
        </Row>
      </div>
    );
  }

  return (
    <div className={style.completedPostcode}>
      <Row justify="stretch" className={style.addressHeaderLine}>
        <T8y bold>Postcode</T8y>
        <T8y
          variant="t2"
          xsVariant="t2v1"
          onClick={
            isWholeSectionDisabled ? undefined : handleFindNewAddressClick
          }
          noWrap
          pointer
          asLink
          className={clsx(
            style.changeAddress,
            isWholeSectionDisabled && style.disabled,
          )}
        >
          Change postcode
        </T8y>
      </Row>
      <T8y variant="t2">{addressByPostcode.postcode}</T8y>
    </div>
  );
};
